import React, { useContext, useEffect, useRef, useState } from "react";
import axios from "axios";
import "./style.scss";
import dummyProfilePic from "../../assets/dummyProfilePic.png";
import DescriptionOutlinedIcon from "@material-ui/icons/DescriptionOutlined";
import ArrowUpwardRoundedIcon from "@material-ui/icons/ArrowUpwardRounded";
import ArrowDownwardRoundedIcon from "@material-ui/icons/ArrowDownwardRounded";
import MoreVertIcon from "@material-ui/icons/MoreVert";
import { Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Button, IconButton, Menu, MenuItem } from "@material-ui/core";
import { AuthContext } from "../../context/authContext/AuthContext";
import { MaterialsContext } from "../../context/materialsContext/MaterialsContext";
import { TasksContext } from "../../context/tasksContext/TasksContext";
import { deleteMaterial } from "../../context/materialsContext/apiCalls";
import { deleteTask } from "../../context/tasksContext/apiCalls";
import formatDatetime from "../../utils/formatDatetime";
import { Link, useHistory, useParams } from "react-router-dom";
import { deleteDoubt } from "../../context/doubtsContext/apiCalls";
import { DoubtsContext } from "../../context/doubtsContext/DoubtsContext";
import ItemForm from "../itemForm/ItemForm";

// Fallback copy function for non-HTTPS environments
const fallbackCopyTextToClipboard = (text) => {
  const textArea = document.createElement("textarea");
  textArea.value = text;
  textArea.style.position = "fixed";
  textArea.style.top = "0";
  textArea.style.left = "0";
  textArea.style.opacity = "0";
  document.body.appendChild(textArea);
  textArea.focus();
  textArea.select();
  try {
    const successful = document.execCommand('copy');
    if (successful) {
      alert('Link copied to clipboard!');
    } else {
      prompt('Copy this link:', text);
    }
  } catch (err) {
    prompt('Copy this link:', text);
  }
  document.body.removeChild(textArea);
};

const DetailedItem = ({ type, data, openEdit }) => {
  const { id: itemId } = useParams();
  const [item, setItem] = useState(null);
  let moreOptions = [];

  const [anchorEl, setAnchorEl] = useState(null);
  const [openConfirmDialog, setOpenConfirmDialog] = useState(false);
  const [openEditForm, setOpenEditForm] = useState(openEdit || false);
  const openMore = Boolean(anchorEl);
  const moreBtn = useRef(null);

  const history = useHistory();
  const { user } = useContext(AuthContext);
  const { dispatch: materialsDispatch } = useContext(MaterialsContext);
  const { dispatch: tasksDispatch } = useContext(TasksContext);
  const { dispatch: doubtsDispatch } = useContext(DoubtsContext);

  const [isDueExpired, setIsDueExpired] = useState(false);
  // Video play UX state - per-video
  const [overlayDismissed, setOverlayDismissed] = useState({}); // overlay removed after user chooses
  const [autoplayFs, setAutoplayFs] = useState({}); // autoplay + fullscreen desired
  const [showLocalPrompt, setShowLocalPrompt] = useState({}); // inline prompt within video frame

  const requestFs = (el) => {
    if (!el) return Promise.resolve();
    const fn = el.requestFullscreen || el.webkitRequestFullscreen || el.mozRequestFullScreen || el.msRequestFullscreen;
    try {
      if (fn) return fn.call(el);
    } catch (_) {}
    return Promise.resolve();
  };

  const exitFs = () => {
    const d = document;
    const fn = d.exitFullscreen || d.webkitExitFullscreen || d.mozCancelFullScreen || d.msExitFullscreen;
    try { if (fn && (d.fullscreenElement || d.webkitFullscreenElement || d.mozFullScreenElement || d.msFullscreenElement)) fn.call(d); } catch(_) {}
  };

  useEffect(() => {
    setItem(data);
  }, [data]);

  useEffect(() => {
    // evaluate due date/time once item is set
    if (type === 'task' && item?.dueDatetime) {
      const due = new Date(item.dueDatetime).getTime();
      const now = Date.now();
      setIsDueExpired(now > due);
    } else {
      setIsDueExpired(false);
    }
  }, [type, item?.dueDatetime]);

  console.log("Item Data:", JSON.stringify(data, null, 2));

  // Check if user can manage this item - compare IDs as strings to handle ObjectId
  const posterIdStr = String(item?.poster?._id || item?.poster || '');
  const userIdStr = String(user?._id || user?.id || '');
  const canManageItem = userIdStr && (userIdStr === posterIdStr || user?.isAdmin);
  
  if (canManageItem) {
    moreOptions = ["Edit", "Delete", "Copy link"];
  } else {
    moreOptions = ["Copy link"];
  }

  if (type === "doubtResponse")
    moreOptions = moreOptions.filter((op) => op !== "Copy link");

  useEffect(() => {
    if (moreOptions.length === 0) moreBtn.current.style.display = "none";
  }, [moreOptions.length]);

  const handleMoreBtnClick = (e) => {
    e.stopPropagation();
    e.preventDefault();
    setAnchorEl(e.currentTarget);
  };

  const handleCloseMore = (e) => {
    e.stopPropagation();
    e.preventDefault();
    setAnchorEl(null);
  };

  const handleDialogBtnClick = async (e) => {
    e.stopPropagation();
    e.preventDefault();

    if (e.target.textContent === "Yes") {
      try {
        if (type === "material") {
          await deleteMaterial(itemId, user, materialsDispatch);
          history.push("/");
        } else if (type === "task") {
          await deleteTask(itemId, user, tasksDispatch);
          history.push("/");
        } else if (type === "doubt" || type === "doubtResponse") {
          await deleteDoubt(itemId, user, doubtsDispatch);
          if (!item.isResponse) {
            history.push("/doubts");
          }
        }
      } catch (err) {
        console.error("Error deleting item:", err);
      }
    }

    setOpenConfirmDialog(false);
  };

  const handleOptionCLick = (e) => {
    e.stopPropagation();
    e.preventDefault();
    setAnchorEl(null);
    console.log(e.target.textContent);

    let selectedOption = e.target.textContent;

    if (selectedOption === "Copy link") {
      let url = window.location.href;
      // Fallback for non-HTTPS environments
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(url).then(() => {
          alert('Link copied to clipboard!');
        }).catch(() => {
          fallbackCopyTextToClipboard(url);
        });
      } else {
        fallbackCopyTextToClipboard(url);
      }
    } else if (selectedOption === "Delete") {
      setOpenConfirmDialog(true);
    } else if (selectedOption === "Edit") {
      setOpenEditForm(true);
    }
  };

  const handleDownload = async (fileUrl) => {
    if (!fileUrl) {
      alert("No file URL provided for download");
      return;
    }

    try {
      console.log("Downloading from:", fileUrl);
      const response = await axios.head(fileUrl);
      if (response.status === 200) {
        const link = document.createElement("a");
        link.href = fileUrl;
        link.setAttribute("download", "");
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      } else {
        alert(`File not found (Status: ${response.status})`);
      }
    } catch (error) {
      console.error("Download error:", error.response || error.message);
      alert("Error downloading file: " + (error.response?.statusText || error.message));
    }
  };

  console.log("Submissions:", JSON.stringify(item?.submissions, null, 2));

  return (
    <>
      {!openEditForm ? (
        <div className={"detailedItem " + type}>
          {type === "doubt" || type === "doubtResponse" ? (
            <>
              <div className="votes">
                <ArrowUpwardRoundedIcon className="icon" />
                <p>{item?.votes}</p>
                <ArrowDownwardRoundedIcon className="icon" />
              </div>
              <div className="itemContent">
                {type === "doubt" && (
                  <div className="topSection">
                    <Link to={`/${type}s/${item?.subject?.name}`} className="link">
                      <h4 className="subject">{item?.subject?.name}</h4>
                    </Link>
                  </div>
                )}
                <div className="bottomSection">
                  <img src={item?.poster?.profilePic || dummyProfilePic} alt="profile" />
                  <div className="textContent">
                    <div className="titleSection">
                      <h4 className="itemTitle">
                        {item?.poster?.fullname +
                          (type === "doubtResponse"
                            ? " answered to this question"
                            : " asked " + item?.title)}
                      </h4>
                      <p>{formatDatetime(item?.createdAt)}</p>
                    </div>
                    <p className="doubtDesc">{item?.description}</p>
                  </div>
                </div>
              </div>
            </>
          ) : (
            <>
              <div className="itemInfo">
                <h1 className="title">{item?.title}</h1>
                <div className="name-and-time">
                  <h5>{item?.poster?.fullname}</h5>
                  <h5 className="Postingtime">{formatDatetime(item?.createdAt)}</h5>
                </div>
                <h5 className="subject">{item?.subject?.name}</h5>

                <div className="attachments">
                  {item?.attachments?.length > 0 ? (
                    item.attachments.map((attachment, index) => (
                      <div className="attachment" key={index}>
                        <DescriptionOutlinedIcon className="icon" />
                        <a
                          href="#"
                          style={{ cursor: "pointer" }}
                          onClick={(e) => {
                            e.preventDefault();
                            if (!attachment?.link) {
                              console.log("Attachment missing link:", attachment);
                              alert("No file link available");
                              return;
                            }
                            handleDownload(attachment.link);
                          }}
                        >
                          {attachment.filename || "Unnamed File"}
                        </a>
                      </div>
                    ))
                  ) : (
                    <p>No attachments available</p>
                  )}
                </div>

              </div>
            
              {/* Right side section for materials: show videos */}
              {type === 'material' && Array.isArray(item?.youtubeLinks) && item.youtubeLinks.length > 0 && (
                <div className="side-videos">
                  <div className="video-section">
                    <h3 className="video-heading">Videos</h3>
                    <div className="video-grid">
                      {item.youtubeLinks.map((link, idx) => {
                        const toEmbed = (urlStr) => {
                          try {
                            const u = new URL(urlStr);
                            if (u.hostname.includes('youtu.be')) {
                              const id = u.pathname.replace('/', '');
                              return `https://www.youtube.com/embed/${id}`;
                            }
                            if (u.pathname === '/watch' && u.searchParams.get('v')) {
                              const id = u.searchParams.get('v');
                              return `https://www.youtube.com/embed/${id}`;
                            }
                            if (u.pathname.startsWith('/shorts/')) {
                              const id = u.pathname.split('/')[2];
                              return `https://www.youtube.com/embed/${id}`;
                            }
                            if (u.pathname === '/playlist' || u.searchParams.get('list')) {
                              const list = u.searchParams.get('list');
                              if (list) return `https://www.youtube.com/embed/videoseries?list=${list}`;
                            }
                            if (u.pathname.startsWith('/embed/')) {
                              return u.toString();
                            }
                          } catch (_) {}
                          return null;
                        };
                        const embed = toEmbed(link);
                        if (!embed) return null;
                        const autoplayEmbed = embed + (embed.includes('?') ? '&' : '?') + 'autoplay=1&playsinline=1';
                        return (
                          <div className="video-wrapper" key={idx} data-video-idx={idx}>
                            {/* overlay to ask user preference */}
                            {!overlayDismissed[idx] && (
                              <button
                                className="video-overlay"
                                aria-label="Play video"
                                onClick={(e) => {
                                  e.preventDefault();
                                  e.stopPropagation();
                                  setShowLocalPrompt((prev) => ({ ...prev, [idx]: true }));
                                }}
                              />
                            )}
                            {showLocalPrompt[idx] && (
                              <div className="fs-prompt" role="dialog" aria-modal="true">
                                <div className="fs-card">
                                  <h4>Play in Full Screen?</h4>
                                  <p>Video frame looks small. Would you like to play it on full screen?</p>
                                  <div className="fs-actions">
                                    <button
                                      className="btn secondary"
                                      onClick={() => {
                                        // No: normal inline playback
                                        setOverlayDismissed((prev) => ({ ...prev, [idx]: true }));
                                        setShowLocalPrompt((prev) => ({ ...prev, [idx]: false }));
                                        exitFs();
                                      }}
                                    >
                                      No
                                    </button>
                                    <button
                                      className="btn primary"
                                      onClick={async () => {
                                        // Yes: fullscreen + autoplay
                                        const wrapper = document.querySelector(`.video-wrapper[data-video-idx="${idx}"]`);
                                        await requestFs(wrapper);
                                        setAutoplayFs((prev) => ({ ...prev, [idx]: true }));
                                        setOverlayDismissed((prev) => ({ ...prev, [idx]: true }));
                                        setShowLocalPrompt((prev) => ({ ...prev, [idx]: false }));
                                      }}
                                    >
                                      Yes
                                    </button>
                                  </div>
                                </div>
                              </div>
                            )}
                            <iframe
                              src={autoplayFs[idx] ? autoplayEmbed : embed}
                              title={`YouTube video ${idx + 1}`}
                              frameBorder="0"
                              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share; fullscreen"
                              allowFullScreen
                              loading="lazy"
                            />
                          </div>
                        );
                      })}
                    </div>
                  </div>
                </div>
              )}

              {type === "task" && (
                <div className="your-work">
                  <div className="topDiv">
                    {item?.dueDatetime && (
                      <h5 className="dueDatetime">
                        Due: {(() => {
                          const d = new Date(item.dueDatetime);
                          if (isNaN(d.getTime())) return '';
                          const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
                          const month = months[d.getMonth()];
                          const date = d.getDate();
                          const year = d.getFullYear();
                          const hours = d.getHours().toString().padStart(2, '0');
                          const minutes = d.getMinutes().toString().padStart(2, '0');
                          return `${month} ${date}, ${year} at ${hours}:${minutes}`;
                        })()}
                      </h5>
                    )}
                  </div>
                  <div className="workinfo">
                    <h3>Your Work</h3>
                    {user.isTeacher && canManageItem && (
                      <button
                        className="subject-action-btn"
                        onClick={() => {
                          const rows = (item?.submissions||[]).map(s=>({
                            name: s.student?.fullname||'',
                            course: s.student?.course||'',
                            status: s.status || (s.file? 'submitted':'pending'),
                            submittedAt: s.submittedAt ? new Date(s.submittedAt).toISOString() : '',
                            file: s.file || ''
                          }));
                          const headers = Object.keys(rows[0]||{ name:'', course:'', status:'', submittedAt:'', file:'' });
                          const csv = [headers.join(','), ...rows.map(r=> headers.map(h=>`"${String(r[h]??'').replace(/"/g,'""')}"`).join(','))].join('\n');
                          const blob = new Blob([csv], {type:'text/csv;charset=utf-8;'});
                          const url = URL.createObjectURL(blob);
                          const a = document.createElement('a');
                          a.href = url; a.download = `${(item?.title||'assignment')}-submissions.csv`; a.click();
                          URL.revokeObjectURL(url);
                        }}
                      >
                        Export CSV
                      </button>
                    )}
                  </div>

                  {user.isTeacher ? (
                    <div className="teacher-actions">
                      <h4>Student Submissions</h4>
                      <table className="student-list">
                        <thead>
                          <tr>
                            <th>Student Name</th>
                            <th>Course</th>
                            <th>Status</th>
                            <th>Submission Date</th>
                            <th>Actions</th>
                          </tr>
                        </thead>
                        <tbody>
                          {item?.submissions?.length > 0 ? (
                            item.submissions.map((submission, index) => (
                              <tr key={submission._id || index}>
                                <td>{submission.student?.fullname || "Unknown"}</td>
                                <td>{submission.student?.course || item.course}</td>
                                <td>
                                  <span className={`status-badge ${submission.status || (submission.file ? "submitted" : "pending")}`}>
                                    {submission.status || (submission.file ? "submitted" : "pending")}
                                  </span>
                                </td>
                                <td>
                                  {submission.submittedAt
                                    ? new Date(submission.submittedAt).toLocaleString()
                                    : "Not submitted"}
                                </td>
                                <td>
                                  {submission.file ? (
                                    canManageItem ? (
                                      <div className="actions-dropdown">
                                        <button className="actions-trigger" onClick={(e)=>{
                                          e.preventDefault();
                                          const menu = e.currentTarget.nextElementSibling;
                                          if(menu){ const open = menu.getAttribute('data-open')==='1'; menu.setAttribute('data-open', open?'0':'1'); }
                                        }}>Actions</button>
                                        <div className="actions-menu" data-open="0">
                                          <span onClick={async ()=>{ try { const baseUrl = process.env.REACT_APP_API_URL || 'http://localhost:5000'; const fileUrl = (submission.file||'').startsWith('http') ? submission.file : `${baseUrl}${submission.file}`; 
                                                window.open(fileUrl,'_blank','noopener'); }
                                                catch(e){ alert('Cannot open file'); } }}>View</span>
                                          <span onClick={async ()=>{ const ok = window.confirm('Request reupload?'); if(!ok) return; try { const res = await axios.post(`/api/task/${item._id}/submission/${submission.student._id}/reupload`,{}, { headers:{ token:`Bearer ${user.accessToken}` }}); if(res.data) setItem(res.data); } catch(e){ alert(e?.response?.data||'Reupload failed'); } }}>ReUpload</span>
                                          <span onClick={async ()=>{ const ok = window.confirm('Accept submission?'); if(!ok) return; try { const res = await axios.post(`/api/task/${item._id}/submission/${submission.student._id}/accept`,{}, { headers:{ token:`Bearer ${user.accessToken}` }}); if(res.data) setItem(res.data); } catch(e){ alert(e?.response?.data||'Accept failed'); } }}>Accept</span>
                                          <span onClick={async ()=>{ const ok = window.confirm('Reject submission?'); if(!ok) return; try { const res = await axios.post(`/api/task/${item._id}/submission/${submission.student._id}/reject`,{}, { headers:{ token:`Bearer ${user.accessToken}` }}); if(res.data) setItem(res.data); } catch(e){ alert(e?.response?.data||'Reject failed'); } }}>Reject</span>
                                        </div>
                                      </div>
                                    ) : (
                                      <span style={{opacity:.5, fontSize:12}}>No actions (not your assignment)</span>
                                    )
                                  ) : (
                                    <div className="actions-dropdown">
                                      <button className="actions-trigger">Actions</button>
                                      <div className="actions-menu">
                                        <span style={{opacity:.4,cursor:'not-allowed'}}>View</span>
                                        <span style={{opacity:.4,cursor:'not-allowed'}}>Accept</span>
                                        <span style={{opacity:.4,cursor:'not-allowed'}}>Reject</span>
                                        <span style={{opacity:.4,cursor:'not-allowed'}}>ReUpload</span>
                                      </div>
                                    </div>
                                  )}
                                </td>
                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td colSpan="5">No submissions yet</td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>
                  ) : (
                    <div className="student-actions">
                      {isDueExpired && !(item?.submissions?.find((s) => s.student._id === user._id)?.status === 'submitted' || item?.submissions?.find((s) => s.student._id === user._id)?.status === 'accepted') ? (
                        <div className="submission-status" style={{background:'#ffefef', border:'1px solid #ffcccc', padding:'12px', borderRadius:'8px'}}>
                          <p className="status-text" style={{color:'#c62828', fontWeight:600}}>
                            You can't upload the assignment, Date Expired of the Assignment, Contact to your Faculty.
                          </p>
                        </div>
                      ) : (
                        // existing student upload UI
                        <>
                          {item?.submissions?.find((s) => s.student._id === user._id)?.status ===
                          "submitted" ? (
                            <div className="submission-status">
                              <p className="status-text">Assignment Submitted</p>
                              {item?.submissions?.find((s) => s.student._id === user._id)?.feedback && (
                                <div className="feedback-box">
                                  <h4>Teacher's Feedback:</h4>
                                  <p>
                                    {item?.submissions?.find((s) => s.student._id === user._id)?.feedback}
                                  </p>
                                </div>
                              )}
                            </div>
                          ) : item?.submissions?.find((s) => s.student._id === user._id)?.status === 'accepted' ? (
                            <div className="submission-status" style={{background:'#e0f7fa'}}>
                              <p className="status-text" style={{color:'#0277bd'}}>Your assignment is accepted</p>
                            </div>
                          ) : item?.submissions?.find((s) => s.student._id === user._id)?.status === 'rejected' ? (
                            <div className="submission-status" style={{background:'#ffebee'}}>
                              <p className="status-text" style={{color:'#c62828'}}>Your assignment is rejected. If you have any query go to the query section</p>
                            </div>
                          ) : item?.submissions?.find((s) => s.student._id === user._id)?.feedback === 'Reupload your assignment!' ? (
                            <div className="submission-status" style={{background:'#fff8e1'}}>
                              <p className="status-text" style={{color:'#f57c00'}}>Reupload your assignment!</p>
                              <div className="submission-buttons">
                                <input
                                  type="file"
                                  id="taskSubmissionReupload"
                                  accept=".pdf"
                                  style={{ display: "none" }}
                                  onChange={async (e) => {
                                    const file = e.target.files[0];
                                    if (!file) return;
                                    const formData = new FormData();
                                    formData.append("submission", file);
                                    try {
                                      const response = await axios.post(
                                        `/api/task/${item._id}/submit`,
                                        formData,
                                        { headers: { token: `Bearer ${user.accessToken}`, "Content-Type": "multipart/form-data" } }
                                      );
                                      if (response.data) setItem(response.data);
                                    } catch (err) {
                                      alert('Upload failed');
                                    }
                                  }}
                                />
                                <button className="upload-btn" style={{background:'#f57c00'}} onClick={()=> document.getElementById('taskSubmissionReupload').click()}>ReUpload (PDF)</button>
                              </div>
                            </div>
                          ) : (
                            <div className="submission-buttons">
                              <input
                                type="file"
                                id="taskSubmission"
                                accept=".pdf"
                                style={{ display: "none" }}
                                onChange={async (e) => {
                                  const file = e.target.files[0];
                                  if (!file) return;
                                  const formData = new FormData();
                                  formData.append("submission", file);
                                  try {
                                    const response = await axios.post(
                                      `/api/task/${item._id}/submit`,
                                      formData,
                                      { headers: { token: `Bearer ${user.accessToken}`, "Content-Type": "multipart/form-data" } }
                                    );
                                    if (response.data) setItem(response.data);
                                  } catch (err) { alert('Failed to submit'); }
                                }}
                              />
                              <button
                                className="upload-btn"
                                onClick={() => document.getElementById("taskSubmission").click()}
                              >
                                Upload Assignment (PDF only)
                              </button>
                            </div>
                          )}
                        </>
                      )}
                    </div>
                  )}
                </div>
              )}
            </>
          )}

          <IconButton
            className="moreBtn"
            ref={moreBtn}
            onClick={handleMoreBtnClick}
            aria-label="more"
            aria-haspopup="true"
            aria-controls="long-menu"
          >
            <MoreVertIcon />
          </IconButton>
          <Menu
            className="moreOptions"
            anchorEl={anchorEl}
            keepMounted
            onClose={handleCloseMore}
            open={openMore}
            getContentAnchorEl={null}
            anchorOrigin={{ vertical: "top", horizontal: "left" }}
            transformOrigin={{ vertical: "top", horizontal: "center" }}
          >
            {moreOptions.map((option) => (
              <MenuItem key={option} value={option} onClick={handleOptionCLick}>
                {option}
              </MenuItem>
            ))}
          </Menu>

          <Dialog
            open={openConfirmDialog}
            onClose={() => setOpenConfirmDialog(false)}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            onClick={(e) => {
              e.stopPropagation();
              e.preventDefault();
            }}
          >
            <DialogTitle id="alert-dialog-title">Are you sure?</DialogTitle>
            <DialogContent>
              <DialogContentText id="alert-dialog-description">
                Do you want to delete <b>{item?.title + " ?"}</b>
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button
                onClick={handleDialogBtnClick}
                style={{ textTransform: "none" }}
                size="large"
              >
                No
              </Button>
              <Button
                onClick={handleDialogBtnClick}
                autoFocus
                style={{ textTransform: "none" }}
                size="large"
              >
                Yes
              </Button>
            </DialogActions>
          </Dialog>

          {/* Inline prompt used; no global dialog */}
        </div>
      ) : (
        <>
          {(user._id === item?.poster._id || user.isAdmin) && (
            <ItemForm
              type={type}
              editForm
              open={openEditForm}
              setOpenEditForm={setOpenEditForm}
              data={item || data}
              setData={setItem}
            />
          )}
        </>
      )}
    </>
  );
};

export default DetailedItem;